export const UserRegistrationType = {
  EMAIL: "EMAIL",
  MOBILE_NUMBER: "MOBILE_NUMBER",
  APPLE: "APPLE",
  FACEBOOK: "FACEBOOK",
  UNKNOWN: "UNKNOWN"
};
